import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE
} from '../../themes'
export const BUTTON = styled.button`
  &:disabled {
    opacity: 0.7 !important;
    cursor: not-allowed !important;
  }
  & {
    cursor: pointer;
    background: transparent;
    outline: none;
    border: 1px solid transparent;
    transition: all 50ms ease-out;
    border-radius: 4px;
  }
  &:hover {
    background-color: ${COLOR.GOLD_1};
    border: 1px solid ${COLOR.GOLD_1};
    color: white;
  }
  &:focus {
    background-color: ${COLOR.GOLD_1};
    border-color: ${COLOR.GOLD_1};
    color: white;
  }
  &:active {
    background-color: ${COLOR.GOLD_1};
    border-color: ${COLOR.GOLD_1};
    color: white;
  }
  &.is-ui-disabled {
    cursor: not-allowed !important;
  }
  .icon-btn {
    width: 100%;
    height: 100%;
    object-fit: contain;
    vertical-align: text-top;
    padding: ${FONT_SIZE.SSMMN};
    margin: 0;
    transition: all 50ms ease-out;
    transition: transform 100ms ease-out;
    box-sizing: border-box;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    user-select: none;
    scrollbar-width: none
  }
  &:focus .icon-btn {
    -webkit-filter: invert(100%);
    filter: invert(100%);
  }
  &:active .icon-btn {
    -webkit-filter: invert(100%);
    filter: invert(100%);
  }
  &.round {
    border-radius: 50%;
  }
`
